import React from 'react';

export default function FileIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g id='iconography/annotation/grid-48x48' opacity='0'>
        <rect fill='currentColor' x='0' y='0' width='32' height='32' />
        <rect stroke='#239C8B' strokeWidth='6' opacity='0.5' x='3' y='3' width='26' height='26' />
        <rect stroke='#239C8B' strokeWidth='0.5' opacity='0.3' x='4.25' y='7.25' width='23.5' height='17.5' rx='5' />
        <path
          d='M23,7.25 C24.3116763,7.25 25.4991763,7.78166186 26.3587572,8.64124279 C27.2183381,9.50082372 27.75,10.6883237 27.75,12 L27.75,12 L27.75,20 C27.75,21.3116763 27.2183381,22.4991763 26.3587572,23.3587572 C25.4991763,24.2183381 24.3116763,24.75 23,24.75 L23,24.75 L9,24.75 C7.68832372,24.75 6.50082372,24.2183381 5.64124279,23.3587572 C4.78166186,22.4991763 4.25,21.3116763 4.25,20 L4.25,20 L4.25,12 C4.25,10.6883237 4.78166186,9.50082372 5.64124279,8.64124279 C6.50082372,7.78166186 7.68832372,7.25 9,7.25 L9,7.25 Z'
          stroke='#239C8B'
          strokeWidth='0.5'
          opacity='0.3'
          transform='translate(16.000000, 16.000000) rotate(-90.000000) translate(-16.000000, -16.000000) '
        />
        <rect stroke='#239C8B' strokeWidth='0.5' x='8.25' y='8.25' width='15.5' height='15.5' rx='7.75' />
        <g id='Group' transform='translate(8.000000, 8.000000)' fill='#32C2AE'>
          <path
            d='M8,8.5 C8.27614237,8.5 8.5,8.27614237 8.5,8 C8.5,7.72385763 8.27614237,7.5 8,7.5 C7.72385763,7.5 7.5,7.72385763 7.5,8 C7.5,8.27614237 7.72385763,8.5 8,8.5 Z'
            id='Oval'
          />
          <polygon
            id='Rectangle'
            opacity='0.330426897'
            points='0 7.91674276 16 7.91674276 16 8.15331824 0 8.15331824'
          />
          <polygon
            id='Rectangle-Copy'
            opacity='0.330426897'
            transform='translate(8.000000, 8.050141) rotate(-90.000000) translate(-8.000000, -8.050141) '
            points='0.465580373 7.93185353 15.5344196 7.93185353 15.5344196 8.16842902 0.465580373 8.16842902'
          />
        </g>
      </g>
      <path
        d='M18,4 L18,10 C18,11.0543618 18.8158778,11.9181651 19.8507377,11.9945143 L20,12 L25,12 L25,26 C25,27.1045695 24.1045695,28 23,28 L9,28 C7.8954305,28 7,27.1045695 7,26 L7,6 C7,4.8954305 7.8954305,4 9,4 L18,4 Z M20,4 L25,10 L21,10 C20.4477153,10 20,9.55228475 20,9 L20,4 Z'
        id='Combined-Shape'
        fill='currentColor'
      />
    </svg>
  );
}
